import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {IonicModule} from '@ionic/angular';

@Component({
  selector: 'app-dashboard-quick-action',
  templateUrl: './dashboard-quick-action.component.html',
  styleUrls: ['./dashboard-quick-action.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule, IonicModule]
})
export class DashboardQuickActionComponent {
  @Input() accessible = false;
  @Input() link: any[] | null = null;
  @Input() label = '';
}
